import React from 'react';

// The Partner Success rep who owns a partner or an account.
//
// ⚠️ THREE STATES, AND COLLAPSING ANY TWO OF THEM MISLEADS SOMEBODY. Shared
// between the Partners and Accounts tables precisely so they cannot drift into
// showing the same fact two different ways:
//
//   1. A NAMED OWNER — a rep holds an active partner_assignments row.
//   2. HELD BY NOBODY — a row exists with staff_user_id NULL. Recorded
//      explicitly: somebody looked and there was no one to give it to. Claiming
//      this partner is the right move.
//   3. NO ROW AT ALL — the partner predates the assignment history entirely.
//      Ownership at any past closing is unanswerable from data, which is a
//      different problem from "nobody owns it now" and needs a human, not a
//      claim. The four partners in this state today are all ARCHIVED test
//      accounts, skipped on purpose by backfillAssignments.js; every live
//      partner has an owner. Seeing this state on a real partner means
//      something went wrong, which is why it is worded as a fact about the
//      record rather than as an invitation to claim them.
//
// ⚠️ WHY IT MATTERS BEYOND TIDINESS: commission on a closing follows whoever held
// the account AT THE CLOSING. State 2 means no rep is owed; state 3 means the
// question cannot be answered and must not be defaulted. Rendering both as
// "Unassigned" invites a rep to claim a partner in the one case where the honest
// answer is "ask someone".
export default function OwnerCell({ name, hasRow, extraCount = 0 }) {
  const clean = (name || '').trim();

  if (clean) {
    return (
      <span style={{ color: '#374151' }}>
        {clean}
        {extraCount > 0 && (
          // More than one rep across an account's partners. Saying "+2" is
          // honest about the ambiguity; picking one name would not be.
          <span style={{ color: '#9ca3af', marginLeft: 4 }}>+{extraCount}</span>
        )}
      </span>
    );
  }

  if (hasRow) {
    return (
      <span style={{ background: '#fff7ed', color: '#b45309', padding: '1px 6px', borderRadius: 6, fontWeight: 700, fontSize: 11 }}>
        No owner
      </span>
    );
  }

  return (
    <span title="This partner predates the ownership history — who held them at a past closing can't be answered from data."
      style={{ color: '#9ca3af', fontStyle: 'italic' }}>
      Not on record
    </span>
  );
}
